__turbopack_context__.v({
  "tesimonial__background": "MWOaEW_tesimonial__background",
  "testemonial__image": "MWOaEW_testemonial__image",
  "testemonial__quote": "MWOaEW_testemonial__quote",
  "testimonial": "MWOaEW_testimonial",
  "testimonial__arrow": "MWOaEW_testimonial__arrow",
  "testimonial__arrow__backward": "MWOaEW_testimonial__arrow__backward",
  "testimonial__arrow__forward": "MWOaEW_testimonial__arrow__forward",
  "testimonial__arrow__hidden": "MWOaEW_testimonial__arrow__hidden",
  "testimonial__bio": "MWOaEW_testimonial__bio",
  "testimonial__dot": "MWOaEW_testimonial__dot",
  "testimonial__dot__active": "MWOaEW_testimonial__dot__active",
  "testimonial__dots": "MWOaEW_testimonial__dots",
  "testimonialtrack": "MWOaEW_testimonialtrack",
  "testimonialtrackinner": "MWOaEW_testimonialtrackinner",
  "wrapper": "MWOaEW_wrapper",
});
